import script from "./MHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MHeader.vue?vue&type=script&setup=true&lang=js"

import "./MHeader.vue?vue&type=style&index=0&id=98432a2a&lang=scss"

const __exports__ = script;

export default __exports__